const HealthPage = () => <>ok</>

export default HealthPage;
